module.exports = __webpack_public_path__ + "img/check-circle-filled.621c12bb.svg";